var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('label',{staticStyle:{"color":"red","font-weight":"normal"},attrs:{"for":"name"}},[_vm._v("\r\n  "+_vm._s(_vm.error?_vm.error[0]:'')+"\r\n")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b8db6a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/error/error.html
// module id = null
// module chunks = 